var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C8.477 2 4 6.477 4 12s4.477 10 10 10 10-4.477 10-10S19.523 2 14 2zm0 2a8 8 0 018 8 7.954 7.954 0 01-1.281 4.33l-.77-.596C18.397 14.537 15.537 14 14 14s-4.398.537-5.95 1.734l-.769.598A7.954 7.954 0 016 12a8 8 0 018-8zm0 1.75A3.254 3.254 0 0010.75 9 3.254 3.254 0 0014 12.25 3.254 3.254 0 0017.25 9 3.254 3.254 0 0014 5.75zm0 2c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25-1.25-.561-1.25-1.25.561-1.25 1.25-1.25zM14 16c3.1 0 4.768 1.169 5.549 1.754A7.966 7.966 0 0114 20a7.966 7.966 0 01-5.549-2.246C9.231 17.169 10.9 16 14 16zm-5.945 1.34zm11.857.035c-.11.12-.22.242-.336.355.117-.113.226-.235.336-.355z",
    fill: "#0A3039"
  })));
}
export default SvgUserCircled;